import ApplicationSerializer from './application';

export default class VfdScheduleSerializer extends ApplicationSerializer {
  attrs = {
    configuration: { serialize: false },
  };
}
